var map = {
	"./ar/translation.json": 1862,
	"./de/translation.json": 1863,
	"./el/translation.json": 1864,
	"./en/translation.json": 1865,
	"./es/translation.json": 1866,
	"./fil/translation.json": 1867,
	"./fr/translation.json": 1868,
	"./hi/translation.json": 1869,
	"./id/translation.json": 1870,
	"./it/translation.json": 1871,
	"./ko/translation.json": 1872,
	"./ms/translation.json": 1873,
	"./nl/translation.json": 1874,
	"./pl/translation.json": 1875,
	"./pt-BR/translation.json": 1876,
	"./pt-PT/translation.json": 1877,
	"./ru/translation.json": 1878,
	"./se/translation.json": 1879,
	"./tr/translation.json": 1880,
	"./uk/translation.json": 1881,
	"./zh/translation.json": 1882
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1861;